<template>
    <div id="partFour" class="part4 part">
        <div class="top" :class="{animate: isAnimate}">
					<div class="title" :class="{animate: isAnimate}">产品与服务</div>	
        </div>
        <p class="center" :class="{animate: isAnimate}">
          互联网的快速发展，带来了信息的爆发式增长，如何及时有效监控、引导、处理网络信息给网信办带来了巨大的挑战
        </p>
        <div class="part4bot">
					<div class="bottom" :class="{animate: isAnimate}">
						<div class="circle circle1"></div>
						<div class="circle circle2"></div>
						<div class="circle circle3"></div>
						<div @click="dialogVisible = true;" class="circle circle4"></div>
						<img src="../../static/images/play.png" alt="">
					</div>
        </div>
				<el-dialog :visible.sync="dialogVisible" width="100%" :close-on-click-modal="false" :show-close="false">
					<video-component :config="videoConfig" v-on:closeVideo="closeDialog"></video-component>
				</el-dialog>
    </div>
</template>
<script>
import Video from "../components/Video"
export default {
    name :"Partfour",
    data(){
        return{
          dialogVisible:false,
          isAnimate:false,
					videoConfig:{
						width:'80%',
						height:'auto',
						url:"https://file.feigeyuxin.com/video/feige.mp4",
						poster:"./static/images/videobg.png"
					}
        }
		},
		components:{
			'video-component':Video
		},
		mounted:function(){
			let obj1 = document.getElementById("partFour").querySelector(".circle1");
			let obj2 = document.getElementById("partFour").querySelector(".circle2");
			let obj3 = document.getElementById("partFour").querySelector(".circle3");
			let obj4 = document.getElementById("partFour").querySelector(".circle4");
			obj1.classList.add('animate');
			obj2.classList.add('animate');
			obj3.classList.add('animate');
			obj4.classList.add('animate');
			obj4.addEventListener("animationend",function(){
				obj1.classList.remove('animate');
				obj2.classList.remove('animate');
				obj3.classList.remove('animate');
				obj4.classList.remove('animate');
				setTimeout(function(){
					obj1.classList.add('animate');
					obj2.classList.add('animate');
					obj3.classList.add('animate');
					obj4.classList.add('animate');
				},1000)
      })
      document.addEventListener("scroll",this.actionAnima);
		},
		methods:{
			closeDialog:function(){
				this.dialogVisible = false;
      },
      actionAnima:function(){
        let _self = this;
        const bodyH = document.body.scrollTop || document.documentElement.scrollTop;
        // console.log(bodyH);
        if(bodyH >= 700){
          _self.isAnimate = true;
        }
      }
		}
}
</script>
<style scoped>
  .part4{
    background: url(../../static/images/part4.jpg) no-repeat;
    background-size: 100% 100%;
    color: #fff;
    padding-top: 80px;
  }
  .part4 .top{
    height: 132px;
    line-height: 132px;
    width: 540px;
    margin: 0px auto 10px auto;
    background: url(../../static/images/service.png) no-repeat;
    background-size: 100% auto;
    background-position: center top;
    text-align: center;
    font-size: 40px;
  }
  .part4 .top.animate{
    animation: topBgDown 0.5s linear forwards;
  }
	.part4 .top .title{
		position: relative;
		opacity: 0;
	}
  .part4 .top .title.animate{
    animation: topUp 0.6s linear forwards;
  }
  .part4 p.center{
    width: 800px;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
    height: 50px;
    opacity: 0;
    /* border: 1px solid red; */
  }
  .part4 p.center.animate{
    animation: topUp 0.6s linear forwards;
		animation-delay:0.5s;
  }
  .part4 .part4bot{
    height: 420px;
  }
  .part4 .bottom{
    height:420px;
    width: 1200px;
    line-height: 460px;
    text-align: center;
    margin: 0 auto;
    background: url(../../static/images/video.png) no-repeat;
    background-size: 100% auto;
		opacity: 0;
    position: relative;
  }
  .part4 .bottom.animate{
    animation: topUp .5s linear forwards;
		animation-delay: 0.8s;
  }
  .part4 .bottom .circle{
    position:absolute;
    left:50%;
    top:60%;
    z-index: 10;
    margin-left: -6px;
    margin-top:-6px;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background: #fff;
    opacity: 0.5;
    transform: scale(1,1);
  }
  .part4 .bottom .circle1.animate{
    animation: circle 1s ease-in-out;
  }
  .part4 .bottom .circle2.animate{
    animation: circle 1s ease-in-out;
    animation-delay: 0.3s;
  }
  .part4 .bottom .circle3.animate{
    animation: circle 1s ease-in-out;
    animation-delay: 0.6s;
  }
  .part4 .bottom .circle4.animate{
    animation: circle 1s ease-in-out;
    animation-delay: 0.9s;
  }
  .part4 .bottom img{
    position:absolute;
    left:50%;
    top:60%;
    margin-left: -36px;
    margin-top:-36px;
  }
	/*------------动画------------*/
  /*播放按钮水波特效*/
  @keyframes circle {
    0%{
      opacity: 0.5;
      transform: scale(1,1);
    }
    100%{
      opacity: 0;
      transform: scale(10,10);
    }
  }
	@keyframes topUp{
		from{
				top: 15px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes topBgDown{
		from{
			background-position: center top;
		}to{
			background-position: center center;
		}
  }
  @media (max-width: 1439px){
    .part4 p.center{
      width: 800px;
    }
    .part4 .bottom{
      width: 1000px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Partfour.vue